module.exports = __webpack_public_path__ + "img/dialog.9af2ddb8.png";